import { clamp } from 'my-utils';

export default function FlashCardDeckImage({ className, title }) {
  return (
    <div
      className={className}
      css={({ palette, shape }) => ({
        backgroundColor: palette.skyblue.light,
        borderRadius: shape.borderRadiusSm,
        display: 'flex',
        justifyContent: 'center',
        padding: '3% 0',
        '> svg': {
          width: '80%',
          maxWidth: 210,
        },
      })}
    >
      <FlashCardDeckSVG title={title} />
    </div>
  );
}

export function FlashCardDeckSVG({ className, title }) {
  return (
    <svg
      className={className}
      css={({ palette, shadows }) => ({
        '.card': {
          // filter: 'url(#cardShadow)',
          filter: 'drop-shadow(1px 2px 2px #DDD)',
          // filter: 'drop-shadow(1px 2px 3px rgba(200, 200, 200, 0.75))',
          boxShadowx: shadows[8],
        },
        '& text': { fill: palette.primary.main },
      })}
      fill="none"
      viewBox="20 20 184 138"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* <defs>
        <filter height="200%" id="cardShadow" width="200%" x="-50%" y="-50%">
          <feDropShadow dx="0" dy="4" floodColor="#000" floodOpacity="0.25" stdDeviation="6" />
        </filter>
      </defs> */}
      <rect
        className="card"
        fill="#F4F7FC"
        height="88.217"
        rx="8"
        transform="rotate(-4 46.92 63.577)"
        width="143.794"
        x="46.921"
        y="63.577"
      />
      <rect
        className="card"
        fill="#F4F7FC"
        height="88.217"
        rx="8"
        transform="rotate(-12 36.154 65.33)"
        width="143.794"
        x="36.154"
        y="65.331"
      />
      <g transform="rotate(-20 24.4 68.895)">
        <rect className="card" fill="#fff" height="88.217" rx="8" width="143.794" x="24.4" y="68.895" />
        <g transform="translate(100,110)">
          <text
            dominantBaseline="middle"
            fontFamily="Mulish, Arial"
            fontSize={clamp(160 / title.length, 0, 20).toFixed(1)}
            fontWeight="900"
            textAnchor="middle"
          >
            {title}
          </text>
          <text
            dominantBaseline="middle"
            fontFamily="Mulish, Arial"
            fontSize="12"
            fontWeight="bold"
            textAnchor="middle"
            y="18"
          >
            Flash Cards
          </text>
        </g>
      </g>
      <circle cx="51.748" cy="107.05" fill="#C5CEE0" r="4.411" />
      <path
        clipRule="evenodd"
        d="M45.374 126.475a11.7 11.7 0 0 1-5.094 1.158c-6.496 0-11.762-5.266-11.762-11.761 0-6.496 5.266-11.762 11.762-11.762 3.931 0 7.412 1.93 9.548 4.893l4.826-1.757c-2.931-4.874-8.272-8.136-14.374-8.136-9.257 0-16.762 7.505-16.762 16.762s7.505 16.761 16.762 16.761c2.425 0 4.73-.515 6.81-1.442z"
        fill="#8392A6"
        fillRule="evenodd"
      />
      <mask
        height="10"
        id="e"
        maskUnits="userSpaceOnUse"
        // style="mask-type:alpha"
        width="10"
        x="47"
        y="102"
      >
        <circle cx="51.748" cy="107.05" fill="#C5CEE0" r="4.411" />
      </mask>
      <g mask="url(#e)">
        <circle cx="40.279" cy="115.872" r="14.261" stroke="#8392A6" strokeWidth="5" />
      </g>
    </svg>
  );
}
